import auth0 from 'auth0-js';
import { EventEmitter } from 'events';
import authConfig from '../../config/auth0Config';
import { auth0LocalStorageKey, ROUTES } from '../constants';

// authService implementation taken from: https://github.com/auth0-samples/auth0-vue-samples/tree/master/01-Login

/* eslint class-methods-use-this: 0
  consistent-return: 0
*/
const webAuth = new auth0.WebAuth({
  domain: authConfig.domain,
  redirectUri: `${window.location.origin}/callback`,
  clientID: authConfig.clientId,
  responseType: 'id_token token',
  scope: 'openid profile email',
  audience: authConfig.audience,
});

const loginEvent = 'loginEvent';

class AuthService extends EventEmitter {
  idToken = null;
  profile = null;
  tokenExpiry = null;

  login(customState) {
    webAuth.authorize({
      appState: customState,
    });
  }

  logout() {
    localStorage.removeItem(auth0LocalStorageKey);

    this.idToken = null;
    this.tokenExpiry = null;
    this.profile = null;

    webAuth.logout({
      returnTo: `${window.location.origin}${ROUTES.HOME}`,
    });

    this.emit(loginEvent, { loggedIn: false });
  }

  handleAuthentication() {
    return new Promise((resolve, reject) => {
      webAuth.parseHash((err, authResult) => {
        if (err) {
          this.emit(loginEvent, {
            loggedIn: false,
            error: err,
            errorMsg: err.statusText,
          });
          reject(err);
        } else {
          this.localLogin(authResult);
          resolve(authResult.idToken);
        }
      });
    });
  }

  getUser() {
    const authResultString = localStorage.getItem(auth0LocalStorageKey);
    if (!authResultString) return null;
    const authResult = JSON.parse(authResultString);
    return authResult.idTokenPayload;
  }

  isAuthenticated() {
    const authResultString = localStorage.getItem(auth0LocalStorageKey);

    if (!authResultString) return false;
    const authResult = JSON.parse(authResultString);

    const profile = authResult.idTokenPayload;

    // Convert the expiry time from seconds to milliseconds,
    // required by the Date constructor
    const tokenExpiry = new Date(profile.exp * 1000);

    return Date.now() < tokenExpiry;
  }

  getIdToken() {
    const authResultString = localStorage.getItem(auth0LocalStorageKey);
    if (!authResultString) return null;
    const authResult = JSON.parse(authResultString);
    return authResult.idToken;
  }

  localLogin(authResult) {
    localStorage.setItem(auth0LocalStorageKey, JSON.stringify(authResult));
    this.idToken = authResult.idToken;
    this.profile = authResult.idTokenPayload;

    // Convert the expiry time from seconds to milliseconds,
    // required by the Date constructor
    this.tokenExpiry = new Date(this.profile.exp * 1000);

    this.emit(loginEvent, {
      loggedIn: true,
      profile: authResult.idTokenPayload,
      state: authResult.appState || {},
    });
  }

  // * UNUSED
  // renewTokens() {
  //   return new Promise((resolve, reject) => {
  //     const authResultString = localStorage.getItem(auth0LocalStorageKey);
  //     if (!authResultString) return reject('Not logged in');

  //     webAuth.checkSession({}, (err, authResult) => {
  //       if (err) {
  //         reject(err);
  //       } else {
  //         this.localLogin(authResult);
  //         resolve(authResult);
  //       }
  //     });
  //   });
  // }
}

const service = new AuthService();

service.setMaxListeners(5);

export default service;



// WEBPACK FOOTER //
// ./src/services/authService.js